import { usePlaceByCoords } from 'hooks/usePlace'

function useExperiencePlace(experience: App.ExperienceOffer) {
  return usePlaceByCoords(experience.location.latitude, experience.location.longitude)
}

export default useExperiencePlace
